import { observable, action, makeObservable, computed } from "mobx";
import { Fields } from "./Fields";
import { validateOpportunityApplication } from "../../logic/ValidationChecks/OpportunityApplicationValidation";

export interface IOpportunityApplication {
    opportunityId: number
    email: string;
    phone: string;
    message: string;
}

export class OpportunityApplication extends Fields<IOpportunityApplication, OpportunityApplication> implements IOpportunityApplication {
    @observable opportunityId: number;
    @observable email = '';
    @observable phone = '';
    @observable message = '';

    constructor(opportunityId: number, email?: string, phone?: string, message?: string) {
        super();

        makeObservable(this);

        this.opportunityId = opportunityId;
        this.email = email || '';
        this.phone = phone || '';
        this.message = message || '';
    }

    @action setEmail(email: string) {
        this.email = email;
    }

    @action setPhone(phone: string) {
        this.phone = phone;
    }

    @action setMessage(message: string) {
        this.message = message;
    }

    @computed get validationErrors() {
        return validateOpportunityApplication(this);
    }

    serialize() {
        return this.trimmed;
    }
}